/**
 * Process button component
 */

// React
import React, { FC } from 'react';

// Libraries
import DownloadIcon from '@mui/icons-material/Download';

// Common styles
import { ButtonProcess } from 'styles';

// Interface
interface ProcessButtonProps {
  disabled?: boolean;
  startIcon?: React.ReactNode;
  content?: string;
  handleDownload?: () => void;
}

// Component
const ProcessButton: FC<ProcessButtonProps> = ({
  handleDownload,
  disabled,
  content = 'CSVダウンロード',
  startIcon = <DownloadIcon />,
}) => {
  return (
    <ButtonProcess
      variant="contained"
      startIcon={startIcon}
      onClick={handleDownload}
      disabled={disabled}
    >
      {content}
    </ButtonProcess>
  );
};

export default ProcessButton;
